import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "timestamp", "side"]

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown, true)

    // Watch for turbo stream updates to score-data element
    this.observer = new MutationObserver(() => this.syncScoreData())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown, true)
    if (this.observer) this.observer.disconnect()
  }

  get video() {
    return this.element.querySelector("video")
  }

  get plyrContainer() {
    return this.element.querySelector(".plyr")
  }

  handleKeydown(event) {
    if (event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA") return

    if (event.key === "h" || event.key === "H") {
      event.preventDefault()
      event.stopImmediatePropagation()
      this.addGoal("home")
    } else if (event.key === "a" || event.key === "A") {
      event.preventDefault()
      event.stopImmediatePropagation()
      this.addGoal("away")
    }
  }

  addGoal(side) {
    const video = this.video
    if (!video || !video.duration) return

    this.timestampTarget.value = video.currentTime
    this.sideTarget.value = side
    this.formTarget.requestSubmit()

    this.flashFeedback(side)
  }

  flashFeedback(side) {
    const container = this.plyrContainer
    if (!container) return

    const color = side === "home" ? "#16a34a" : "#2563eb"
    let overlay = container.querySelector("#goal-flash")
    if (!overlay) {
      overlay = document.createElement("div")
      overlay.id = "goal-flash"
      overlay.style.cssText = "position:absolute;inset:0;pointer-events:none;z-index:100;transition:opacity 0.4s;"
      container.style.position = "relative"
      container.appendChild(overlay)
    }

    overlay.style.border = `3px solid ${color}`
    overlay.style.display = "block"
    overlay.style.opacity = "1"

    setTimeout(() => {
      overlay.style.opacity = "0"
      setTimeout(() => {
        overlay.style.display = "none"
        overlay.style.opacity = "1"
      }, 400)
    }, 300)
  }

  syncScoreData() {
    const scoreDataEl = document.getElementById("score-data")
    if (!scoreDataEl) return

    const newTimeline = scoreDataEl.dataset.scoreTimeline
    if (!newTimeline) return

    // Update the score controller's value attribute to trigger scoreTimelineValueChanged
    const scoreEl = this.element.querySelector("[data-controller*='score']")
    if (scoreEl) {
      scoreEl.dataset.scoreScoreTimelineValue = newTimeline
    }
  }
}
